const accesses = () => [
  {
    id: 0,
    title: 'Местоположение',
    warning: 'Местоположения',
    prompt: 'Местоположению',
  },
  {
    id: 1,
    title: 'Камера',
    warning: 'Камеры',
    prompt: 'Камере',
  },
  {
    id: 2,
    title: 'Контакты',
    warning: 'Контактов',
    prompt: 'Контактам',
  },
  {
    id: 3,
    title: 'Микрофон',
    warning: 'Микрофона',
    prompt: 'Микрофону',
  },
  {
    id: 4,
    title: 'Звонок',
    warning: 'Звонка',
    prompt: 'Звонку',
  },
  {
    id: 5,
    title: 'Сообщения',
    warning: 'Сообщений',
    prompt: 'Сообщениям',
  },
  {
    id: 6,
    title: 'Память',
    warning: 'Памяти',
    prompt: 'Памяти',
  },
  {
    id: 7,
    title: 'Вспышка',
    warning: 'Вспышки',
    prompt: 'Вспышке',
  },
]

export default accesses()
